import { DeleteOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useIntegrationStateContext } from "../context/IntegrationStateContext";
interface DeleteButtonProps {
  name: string | undefined;
  text?: string;
  containerStyle?: React.CSSProperties;
  buttonStyle?: React.CSSProperties;
  disable?: boolean;
}

export function DeleteIntegrationButton({
  name,
  text,
  containerStyle,
  buttonStyle,
  disable,
}: DeleteButtonProps) {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    deleteIntegrationState,
    deleteIntegration,
    setDeleteIntegrationState,
    setActiveCell,
    refreshIntegrations,
  } = useIntegrationStateContext();

  const onDeleteIntegration = async () => {
    setDeleteIntegrationState({ loading: true, error: false });
    const result = await deleteIntegration();
    setDeleteIntegrationState({ loading: false, error: result.error });

    if (result.error) return;

    setActiveCell(null);

    setIsModalOpen(false);
    setDeleteIntegrationState({ loading: false, error: false });
    refreshIntegrations();
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setDeleteIntegrationState({ loading: false, error: false });
    setIsModalOpen(false);
  };

  return (
    <div
      style={
        containerStyle
          ? containerStyle
          : {
              position: "absolute",
              bottom: 24,
              left: 0,
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }
      }
    >
      <Button
        type="primary"
        danger
        disabled={disable}
        onClick={showModal}
        style={buttonStyle ? buttonStyle : { width: "50%", height: "40px" }}
      >
        <DeleteOutlined /> {text ? text : t("delete")}
      </Button>
      <Modal
        title={t("delete")}
        open={isModalOpen}
        onOk={onDeleteIntegration}
        onCancel={closeModal}
        confirmLoading={deleteIntegrationState.loading}
      >
        {deleteIntegrationState.error ? (
          <p style={{ color: "#EC5B56" }}>
            <strong>{t("error-delete")}</strong>
          </p>
        ) : (
          <p>
            <Trans
              i18nKey="confirm-delete"
              values={{ name }}
              components={{ bold: <strong /> }}
            />
          </p>
        )}
      </Modal>
    </div>
  );
}
